import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16">
      <div className="relative max-w-5xl mx-auto rounded-2xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20photography%20composition%20with%20smartphone%20capturing%20golden%20light%2C%20abstract%20bokeh%20background%20with%20terracotta%20and%20cream%20tones%2C%20elegant%20minimalist%20studio%20scene%2C%20soft%20shadows%20and%20highlights%2C%20modern%20creative%20atmosphere%2C%20inspirational%20photography%20mood&width=1400&height=600&seq=cta-selfie-inspiration&orientation=landscape"
          alt="开始你的自拍学习之旅"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/85 to-secondary-950/50"></div>
        <div className="relative z-10 px-6 py-14 md:py-20 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
            准备好拍出让人惊艳的自拍了吗？
          </h2>
          <p className="text-background-200/90 text-sm max-w-lg mx-auto mb-8 leading-relaxed">
            掌握国产自拍核心技巧，从今天开始，让每一张自拍都成为值得分享的精彩瞬间
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/goutu-jiqiao"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始免费学习
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/25 transition-colors border border-background-50/25 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}